import {
  TRANSACTION_DETAILS_SUCCESS,
  TRANSACTION_DETAILS_FAILED,
  RESET_TRANSACTION_DETAILS,
  LOADING_TRANSACTION_DETAILS,
  NETWORK_ERROR_TRANSACTION_DETAILS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkerror: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_TRANSACTION_DETAILS: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case TRANSACTION_DETAILS_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case TRANSACTION_DETAILS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_TRANSACTION_DETAILS: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case RESET_TRANSACTION_DETAILS: {
      return (state = initialState);
    }
    default:
      return state;
  }
};
